module.exports = __webpack_public_path__ + "img/9-5.3502ceb8.jpg";